import { Box, Tab, Tabs, alpha } from '@mui/material'

export interface LobTabItem {
    key: string
    label: string
}

export interface LobTabsProps {
    tabs: LobTabItem[]
    /** Index of the active line of business. */
    activeIndex: number
    onTabChange: (index: number) => void
    ariaLabel?: string
}

// Line-of-business capsules shared by the flights and hotels home search forms
// (Flights | Hotels | Flights + Hotels / Visa). Pill row that overlaps the form card
// below it. Desktop-only, matching the home layout on both verticals.
const LobTabs: React.FC<LobTabsProps> = ({ tabs, activeIndex, onTabChange, ariaLabel = 'line of business tabs' }) => (
    <Box
        sx={{
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'common.white',
            borderRadius: 5,
            border: 1,
            borderColor: 'grey.200',
            py: 1.5,
            px: 2.5,
            width: 'fit-content',
            mx: 'auto',
            position: 'relative',
            zIndex: 2
        }}
    >
        <Tabs
            value={activeIndex}
            onChange={(_, next: number) => onTabChange(next)}
            aria-label={ariaLabel}
            sx={{
                minHeight: 'unset',
                '& .MuiTabs-flexContainer': { gap: 1 },
                '& .MuiTab-root': {
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    color: 'grey.600',
                    px: 3,
                    py: 1,
                    minWidth: 'unset',
                    minHeight: 'unset',
                    borderRadius: 0.5,
                    position: 'relative',
                    transition: 'all 0.2s ease',
                    '&.Mui-selected': {
                        fontWeight: 600,
                        color: 'primary.main',
                        bgcolor: theme => alpha(theme.palette.primary.main, 0.1),
                        // Pill outline via an inset shadow rather than `border` (no layout shift).
                        boxShadow: theme => `inset 0 0 0 1.5px ${alpha(theme.palette.primary.main, 0.3)}`,
                        borderRadius: 5,
                        zIndex: 1
                    }
                },
                '& .MuiTabs-indicator': { display: 'none' }
            }}
        >
            {tabs.map(tab => (
                <Tab key={tab.key} label={tab.label} />
            ))}
        </Tabs>
    </Box>
)

export { LobTabs }
export default LobTabs
